import { useEffect } from 'react';
import { withRouter, InjectedRouter } from 'react-router';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { getCurrentUser } from '@core/utils/currentUser';
import { currentUserId } from '@core/selectors/user';
import { institutionShortName } from '@core/selectors/institution';
import { getLoginLandingPath } from '@app/utils/homeLanding';
import { getStore } from '../store';

type InitialRouteRedirectProps = {
  router: InjectedRouter;
};

/**
 * Resolves the post-login landing route after LaunchDarkly has identified the user.
 */
const InitialRouteRedirect = ({ router }: InitialRouteRedirectProps) => {
  const ldClient = useLDClient();

  useEffect(() => {
    let cancelled = false;

    const resolveLandingPath = async () => {
      if (!getCurrentUser()) {
        if (!cancelled) {
          router.replace('/dashboard');
        }
        return;
      }

      if (ldClient) {
        try {
          const state = getStore().getState();
          const userId = currentUserId(state);
          const institution = institutionShortName(state);

          if (userId) {
            await ldClient.identify({
              kind: 'user',
              key: userId,
              institution,
            });
          }
        } catch {
          // Fall through and use whatever flags are currently available
        }
      }

      if (!cancelled) {
        router.replace(getLoginLandingPath(ldClient));
      }
    };

    resolveLandingPath();

    return () => {
      cancelled = true;
    };
  }, [ldClient, router]);

  return null;
};

export default withRouter(InitialRouteRedirect);
